exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".big-flag{outline:3px solid #ced4da;transform:scale(.84)!important;margin-right:6px!important;border-radius:.42rem;opacity:.5;transition:.16s}.big-flag:hover{opacity:1}.selected{outline-color:#9881f6;opacity:1}", ""]);

// exports
